// Class names the flow editor's stylesheet, the legacy pages and the acceptance suite select
// on. They are kept verbatim while the markup underneath moves to the Design System.
export const FLOW_STEP_LEGACY_CLASS = {
    CARD: 'recruitment-flow-step-section',
    NAME_BLOCK: 'recruitment-flow-step-block step-name-container',
    NAME: 'step-display-name',
    STATUS: 'step-display-status',
    DRAG_HANDLE: 'recruitment-flow-step-drag-handle',
    ANONYMOUS: 'anonymous-setting-container',
    REMOVE: 'recruitment-flow-step-remove-btn',
    VIDEO_LINK: 'recruitment-flow-step-video-interview-link',
};

export const FLOW_STEP_ICON = {
    DEFAULT: 'icon-svg-circle',
    REMOVE: 'x-close',
    VIDEO: 'icon-svg-video-recorder',
    ANONYMOUS: 'icon-svg-incognito',
    ANONYMOUS_SETTINGS: 'icon-svg-sliders-02',
};

export const FLOW_STEP_VIDEO_TYPE = 'TaVideoInterview';

// A step whose status is 0 is closed to editing.
export const FLOW_STEP_LOCKED_STATUS = 0;
